import { render, staticRenderFns } from "./index-simple.vue?vue&type=template&id=30dc0708"
import script from "./index-simple.vue?vue&type=script&lang=js"
export * from "./index-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports